import { useState, useEffect, useCallback } from 'react';

const SCRIPT_ID = 'onlyoffice-api-script';

/**
 * Loads the OnlyOffice DocsAPI script (web-apps/apps/api/documents/api.js)
 * from the Document Server and reports readiness.
 */
export default function useOnlyOfficeScript(onlyOfficeUrl) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    if (!onlyOfficeUrl) return;

    // Already available on window
    if (window.DocsAPI) {
      setLoaded(true);
      return;
    }

    // Script tag already in DOM — wait for it
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => setLoaded(true));
      existing.addEventListener('error', () => setError('Failed to load OnlyOffice script'));
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `${onlyOfficeUrl}/web-apps/apps/api/documents/api.js`;
    script.async = true;
    script.onload = () => setLoaded(true);
    script.onerror = () => setError('Failed to load OnlyOffice script');
    document.head.appendChild(script);
  }, [onlyOfficeUrl]);

  useEffect(() => {
    setError(null);
    setLoaded(!!window.DocsAPI);
    load();
  }, [load]);

  return { loaded, error, retry: load };
}
